import Marquee from "react-fast-marquee";
import { site } from "../content";

export const MarqueeStrip = () => {
  const items = [...site.marquee, ...site.marquee, ...site.marquee];
  return (
    <div
      className="border-y border-[#EFE6DC] py-8 md:py-10 overflow-hidden"
      aria-hidden="true"
      data-testid="marquee-strip"
    >
      <span className="sr-only">{site.marquee.join(" • ")}</span>
      <Marquee speed={28} gradient={false} pauseOnHover={false}>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl md:text-3xl text-[#2B2724]/60 px-8">{t}</span>
            <span className="w-2 h-2 rounded-full bg-[#7C8C7E]/60" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
